import notice from '../../src/views/setting/notice'
import basic from '../../src/views/setting/basic'
import purviewMdPage from '../../src/views/setting/purview/mdPage'
import purviewGroup from '../../src/views/setting/purview/group'
import purviewProject from '../../src/views/setting/purview/project'
import purviewRole from '../../src/views/setting/purview/role'
import approvalCreate from '../../src/views/setting/approval/create'
import approvalTypeList from '../../src/views/setting/approval/typeList'
import approvalModelList from '../../src/views/setting/approval/modelList'
import approvalList from '../../src/views/setting/approval/list'
import templateMdPage from '../../src/views/setting/template/mdPage'
import templateProject from '../../src/views/setting/template/project'
import templateCreate from '../../src/views/setting/template/create'

export default {
  basic:basic,
  notice: notice,
  purview:{
    mdPage:purviewMdPage,
    group:purviewGroup,
    project:purviewProject,
    role:purviewRole,
  },
  approval:{
    create:approvalCreate,
    typeList:approvalTypeList,
    modelList:approvalModelList,
    list:approvalList,
  },
  template:{
    mdPage: templateMdPage,
    project: templateProject,
    create: templateCreate,
  },
}
